import { reducer as sharedInterpReducer } from '../shared/interpReducer';
import { MEASURE } from '../../../constants/reading/MeasuresConstants';
import { FETCH_READING_INTERPS } from '../../actionTypes/reading/apiActionTypes';
import parseDecodingInterps from './interpReducerParsers';
import getDyslexiaInterpBoundaries from '../../../utils/reading/interpHelper';
import {
    parseBasicComprehensionInterps,
    parseDyslexiaInterps,
    parseInterps,
} from '../shared/interpReducerParsers';

export const initialState = {
    data: [],
    isAllInterpsFetched: false,
    isR3DInterpsFetched: false,
    error: null,
};

const { RAN } = MEASURE;

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case FETCH_READING_INTERPS.D8:
        case FETCH_READING_INTERPS.D8_COMPOSITE:
            return {
                ...state,
                data: [...state.data, ...parseInterps(action.response)],
            };
        case FETCH_READING_INTERPS.MAZE:
            return {
                ...state,
                data: [...state.data, ...parseBasicComprehensionInterps(action.response)],
            };
        case FETCH_READING_INTERPS.DECODING:
            return {
                ...state,
                data: [...state.data, ...parseDecodingInterps(action.response)],
            };
        case FETCH_READING_INTERPS.RAN:
            return {
                ...state,
                data: [
                    ...state.data,
                    ...parseDyslexiaInterps(action.response, RAN, getDyslexiaInterpBoundaries),
                ],
            };
        default:
            return sharedInterpReducer(state, action);
    }
};
